export * from "./QuizMCQSingleAnswer";
